App.controller('HealthInsuranceInfoStandardCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceInfo_standard';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Standardy dostępności';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);
}]);
